import { Modal, Carousel, Table } from "react-bootstrap";
import React from "react";
import "./ModalFichaMedicamento.css";
import { useState } from "react";
import { ModalPopUpCompraMedicamento } from "./ModalPopUpCompraMedicamento";
import { ModalStockMedicamento } from "./ModalStockMedicamento";
import { ModalPopUp } from "./ModalPopUp";
import { ModalLoading } from "./ModalLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faClipboardQuestion,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { setMedicamentosFiltrados } from "../../../slices/medicamentosSlice";

export const ModalFichaMedicamento = ({
  showModalFichaMedicamento,
  handleCloseModalFichaMedicamento,
  medicamento,
}) => {
  const dispatch = useDispatch();
  const [showModalPopUpCompraMedicamento, setShowModalPopUpCompraMedicamento] =
    useState(false);
  const [showStockMedicamento, setShowStockMedicamento] = useState(false);
  const [showModalPopUp, setShowModalPopUp] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const { medicamentos } = useSelector((state) => state.medicamentos);
  const [alertaBioequivalentes, setAlertaBioequivalentes] = useState(false);
  const verBioequivalentes = () => {
    // const bioequivalentes = medicamentos.filter(
    //   (m) =>
    //     m.principio_activo === medicamento.principio_activo &&
    //     m.concentracion === medicamento.concentracion &&
    //     (m.bioequivalente === "BE" || m.bioequivalente === "REF")
    // );
    const bioequivalentes = medicamentos.filter(
      (m) =>
        m.grupo_bioequivalente === medicamento.grupo_bioequivalente &&
        (medicamento.bioequivalente === "BE" ||
          medicamento.bioequivalente === "REF"),
    );
    if (bioequivalentes.length > 0) {
      dispatch(setMedicamentosFiltrados(bioequivalentes));
      handleCloseModalFichaMedicamento();
    } else {
      setAlertaBioequivalentes(true);
      setTimeout(() => {
        setAlertaBioequivalentes(false);
      }, 3000);
    }
  };

  const goVenta = () => {
    setShowModalPopUpCompraMedicamento(true);
  };

  const goStock = () => {
    // setShowModalLoading(true)
    setShowStockMedicamento(true);
    // setShowModalLoading(false)
  };

  const abrirPopUp = () => {
    setShowModalPopUp(true);
  };

  return (
    <Modal
      className="text-center"
      show={showModalFichaMedicamento}
      onHide={handleCloseModalFichaMedicamento}
      size="xl"
      centered={true}
    >
      <Modal.Header className="header-modal">
        <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10  text-start">
          <Modal.Title style={{ fontSize: "1.2rem" }}>
            {medicamento.nombre_medicamento} | {medicamento.contenido}
          </Modal.Title>
        </div>
        <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 text-end">
          <FontAwesomeIcon
            icon={faXmark}
            size="xl"
            onClick={handleCloseModalFichaMedicamento}
            className="icon-ficha"
          />
        </div>
      </Modal.Header>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-center pt-3 pb-3">
          <Carousel
            data-bs-theme="dark"
            className="carousel-modal"
            indicators={false}
            controls={false}
          >
            {medicamento.image.map((image, index) => (
              <Carousel.Item interval={2000}>
                <img
                  key={index}
                  className="d-block w-100"
                  src={image.url}
                  alt=""
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
          <Modal.Body className="p-3">
            <div className="container ">
              <div className="row pt-3 pb-2">
                <div className="col align-self-end">
                  <Table className="table ">
                    <tbody className="cont-ficha">
                      <tr>
                        <td>
                          <strong>Laboratorio</strong>
                        </td>
                        <td>{medicamento.laboratorio}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Bioequivalente</strong>
                        </td>
                        <td>{medicamento.bioequivalente}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Concentración</strong>
                        </td>
                        <td>{medicamento.concentracion}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Principio Activo</strong>
                        </td>
                        <td>{medicamento.principio_activo}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Clase Terapéutica</strong>
                        </td>
                        <td>{medicamento.clas_terapeutica}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Refrigerado</strong>
                        </td>
                        <td>{medicamento.refrigerado ? "SI" : "NO"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Condición de Venta</strong>
                        </td>
                        <td>
                          {/* {medicamento.cond_venta ===
                          "Receta Medica Retenida sin Control de Stock"
                            ? "Venta bajo Receta Retenida"
                            : null}
                          {medicamento.cond_venta ===
                            "Receta Medica Retenida con Control de Stock" &&
                          medicamento.tipo_controlado === "PSI"
                            ? "Venta bajo Receta Cheque"
                            : null}
                          {medicamento.cond_venta ===
                            "Receta Medica Retenida con Control de Stock" &&
                          medicamento.tipo_controlado !== "PSI"
                            ? "Venta bajo Receta Retenida"
                            : null}
                          {medicamento.cond_venta === "Receta Medica"
                            ? "Venta requiere Receta Médica"
                            : null}
                          {medicamento.cond_venta === "Directa"
                            ? "Venta Directa"
                            : null} */}
                          {medicamento.tipo_venta ===
                          "Receta Medica Retenida" ? (
                            <p>Venta bajo Receta Retenida</p>
                          ) : null}
                          {medicamento.tipo_venta === "Receta Cheque" ? (
                            <p>Venta bajo Receta Cheque</p>
                          ) : null}

                          {medicamento.tipo_venta === "Receta Medica" ? (
                            <p>Venta requiere Receta Médica</p>
                          ) : null}
                          {medicamento.tipo_venta === "Directa" ? (
                            <p>Venta Directa</p>
                          ) : null}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Programa Apoyo</strong>
                        </td>
                        <td>{medicamento.pap_maestro ? "SI" : "NO"}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                {medicamento.nombre_medicamento.includes("SYNACTHEN DEPOT") ? (
                  <h6 style={{ color: "#e58f2f" }}>
                    MEDICAMENTO DISPONIBLE PARA IMPORTACIÓN
                  </h6>
                ) : medicamento.comercio_elec === false ||
                  medicamento.tipo_venta === "Receta Cheque" ? (
                  <h6 style={{ color: "#e58f2f" }}>
                    MEDICAMENTO DISPONIBLE SOLO PARA VENTA PRESENCIAL
                  </h6>
                ) : null}
              </div>
            </div>
            <div className="container text-center">
              <div className="row pb-2">
                <div className="col-12 d-flex justify-content-center align-items-center gap-2 pb-2">
                  <h5 className="precio mb-0">
                    {`$${
                      medicamento.precio_con_dscto
                        ? medicamento.precio_con_dscto.toLocaleString("es-CL")
                        : medicamento.precio.toLocaleString("es-CL")
                    }`}
                  </h5>

                  {medicamento.precio !== medicamento.precio_con_dscto && (
                    <p className="precio-anterior original mb-0 text-decoration-line-through">
                      {`$${medicamento.precio.toLocaleString("es-CL")}`}
                    </p>
                  )}
                </div>

                <div className="col-12 pb-2">
                  <p className="mb-0">
                    Precio por comprimido fraccionado:{" "}
                    {`$${medicamento.precio_unitario.toLocaleString("es-CL")}`}
                  </p>
                </div>
              </div>
            </div>
            {medicamento.bioequivalente !== "NO" ? (
              <div className="row">
                <div className="col-7 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 pe-0 ps-2">
                  <button
                    className="boton-modal bioeq"
                    onClick={verBioequivalentes}
                  >
                    VER BIOEQUIVALENTES
                  </button>
                </div>
                <div className="col-5 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 ps-0 pe-2">
                  {medicamento.tipo_venta !== "Receta Cheque" &&
                  medicamento.comercio_elec === true ? (
                    medicamento.image[0].url ===
                    "/static/media/sin_foto.5f9ed34dcfa0bb8ca88c.png" ? (
                      <button
                        className="boton-modal compra-modal-disabled"
                        disabled
                      >
                        COMPRAR AQUI
                      </button>
                    ) : (
                      <button
                        className="boton-modal compra-modal"
                        onClick={goVenta}
                      >
                        COMPRAR AQUI
                      </button>
                    )
                  ) : (
                    <button
                      className="boton-modal stock-modal"
                      onClick={goStock}
                    >
                      REVISAR STOCK
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  {medicamento.nombre_medicamento.includes(
                    "SYNACTHEN DEPOT",
                  ) ? (
                    <button
                      onClick={abrirPopUp}
                      type="button"
                      className="boton-modal contacto-modal"
                    >
                      CONSULTAR DISPONIBILIDAD
                      <FontAwesomeIcon
                        icon={faClipboardQuestion}
                        className="icono"
                      />
                    </button>
                  ) : medicamento.tipo_venta !== "Receta Cheque" ? (
                    medicamento.image[0].url ===
                    "/static/media/sin_foto.5f9ed34dcfa0bb8ca88c.png" ? (
                      <button
                        className="boton-modal compra-modal-disabled"
                        disabled
                      >
                        COMPRAR AQUI
                      </button>
                    ) : (
                      <button
                        className="boton-modal compra-modal"
                        onClick={goVenta}
                      >
                        COMPRAR AQUI
                      </button>
                    )
                  ) : (
                    <button
                      className="boton-modal stock-modal"
                      onClick={goStock}
                    >
                      REVISAR STOCK
                    </button>
                  )}
                </div>
              </div>
            )}
            {alertaBioequivalentes ? (
              <div className="row pt-3">
                <div className="alerta-buscador" role="alert" style={{borderRadius: 20}}>
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    className="pe-2"
                  />
                  <strong>No hay bioequivalentes disponibles por ahora</strong>
                </div>
              </div>
            ) : null}

            {showModalPopUpCompraMedicamento ? (
              <ModalPopUpCompraMedicamento
                showModalPopUpCompraMedicamento={
                  showModalPopUpCompraMedicamento
                }
                handleCloseModalPopUpCompraMedicamento={() =>
                  setShowModalPopUpCompraMedicamento(
                    !showModalPopUpCompraMedicamento,
                  )
                }
                medicamento={medicamento}
              />
            ) : null}
            {showStockMedicamento && !showModalLoading ? (
              <ModalStockMedicamento
                showStockMedicamento={showStockMedicamento}
                handleCloseStockMedicamento={() =>
                  setShowStockMedicamento(!showStockMedicamento)
                }
                medicamento={medicamento}
              />
            ) : null}
            {showModalLoading ? (
              <ModalLoading showModalLoading={showModalLoading} />
            ) : null}
            {showModalPopUp ? (
              <ModalPopUp
                showModalPopUp={showModalPopUp}
                handleCloseModalPopUp={() => setShowModalPopUp(!showModalPopUp)}
              />
            ) : null}
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};
